import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Freedraw = {
  Component,
  makeDefault,
  isValidData,
} as const;

export type { FreedrawData, FreedrawNodeData } from './types';
